import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useNavigation } from '../../../contexts/navigation';
import styles from "./MenuItem.module.css"
import clsx from "clsx"
const MenuItem = ({ item, isFirstOfGroup, isLastOfGroup }) => {
    const {
        navigationData: { currentPath },
    } = useNavigation();
    const isSelected = useMemo(() => {
        return item.path == currentPath || `/${item.path}` == currentPath;
    }, [item, currentPath])
    return (
        <Link to={item.path} className={clsx(
            styles.memu_item,
            isSelected ? styles.selected : "",
            isFirstOfGroup ? styles.first : "",
            isLastOfGroup ? styles.last : ""
        )}>

            <div className={styles.icon}>
                <i className={item.icon}></i>
            </div>
            <div className={styles.text}>
                <Link to={item.path}>{item.name}</Link>
            </div>

        </Link>
    );
};

export default MenuItem;